<template>
  <div ref="player">
    <UserPlayer v-if="role === 'journalist'"></UserPlayer>
    <SecretaryPlayer v-if="role === 'secretary' || role === 'admin'"></SecretaryPlayer>
    <ModeratorPlayer v-if="role === 'moderator'"></ModeratorPlayer>
  </div>
</template>

<script>
import UserPlayer from "../components/UserPlayer";
import SecretaryPlayer from "../components/SecretaryPlayer";
import ModeratorPlayer from "../components/ModeratorPlayer";
import {mapState} from "vuex";
import Cryptr from "crypto-js";
import app from "../firebaseConfig/config";
import apiService from "@/service/service";

export default {
  name: "userPlayer",
  data: () => {
    return {
      chatsRef: '',
      usersRef: '',
      code: '',
    }
  },
  components: {
    UserPlayer,
    SecretaryPlayer,
    ModeratorPlayer
  },
  computed: {
    ...mapState(['role', 'isChatActivated'])
  },
  methods: {
    getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    async verifyUser() {
      /*const user = await app.auth().currentUser*/
      try {
        const accessToken = await app.auth().currentUser.getIdToken(true)
        const verifyUser = {email: this.getCookie('email'),company: 'Payment Hub', isUserWithPassword: false}

        await apiService.verifyCredentials(verifyUser, accessToken)
        this.$store.commit('updateIsLoading',false)
        //const userLogged = Cryptr.AES.decrypt(this.getCookie('UserLogged'), 'secret key 1234').toString(Cryptr.enc.Utf8) === 'true'

      } catch (e) {
        await this.$router.push({path: '/prensa'})
      }


      // if (!user && !userLogged) await this.$router.push({path: '/login'})
    },
    /**
     * Set cookie of information passed by params
     * @param cookieName
     * @param cookieValue
     * @param encrypted
     */
    setCookie(cookieName, cookieValue, encrypted) {
      const now = new Date()
      const time = now.getTime()
      const expireTime = time + 1000 * 36000
      now.setTime(expireTime)
      encrypted ? document.cookie = cookieName + "=" + Cryptr.AES.encrypt(cookieValue, 'secret key 1234').toString() + "; expires=" + now.toUTCString() : document.cookie = cookieName + "=" + cookieValue + "; expires=" + now.toUTCString()
    },
    /**
     * Set listener in realTime database that detects when user disconnects from the page
     */
    onUserDisconnect() {
      if (!this.isUpdated) {
        this.isUpdated = true
        const cookie = this.getCookie('email')
        const code = this.code
        this.usersRef.once("value", function (snapshot) {
          snapshot.forEach(async function (childSnapshot) {
            const childData = childSnapshot.val();
            if (childData.email === cookie) {
              const myUser = app.database().ref(`lallucana/${code}/users/${childSnapshot.key}`)
              await myUser.onDisconnect().remove()
            }
          });
        })
        this.$store.commit('updateIsLoading', false)
      }
    },
    /**
     * Verify user in real time database because only one email can be connected in same webinar at the same time
     * @returns {Promise<void>}
     */
    async verifyUserInFirebase() {
      try {
        const snapshot = await this.usersRef.orderByChild('email').equalTo(this.getCookie('email')).once("value");
        if (snapshot.exists()) {
          const userLogged = Cryptr.AES.decrypt(this.getCookie('UserLogged'), 'secret key 1234').toString(Cryptr.enc.Utf8)
          if (userLogged === "true") {
            this.onUserDisconnect()
          } else {
            await this.$router.push('/')
          }
        } else {
          document.cookie = document.cookie = "UserLogged=" + Cryptr.AES.encrypt('true', 'secret key 1234').toString()
          this.usersRef.push({
            name: this.getCookie('name'),
            email: this.getCookie('email')
          })
          this.onUserDisconnect();
        }
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Verify Height of user widow for make page more responsive
     */
    matchHeight() {
      if (document.documentElement.clientWidth <= 1199) {
        this.isSmallDevice = true;
        this.chatSmallDeviceActive = ''
      } else {
        this.chatSmallDeviceActive = ''
        this.isSmallDevice = false
        this.goBack = false
        if (this.isChatActivated && this.role !== 'user') {
          setTimeout(function () {
            const conversationPanel = document.getElementById('conversation-panel');
            conversationPanel.scrollTop = conversationPanel.clientHeight;
            conversationPanel.scrollTop = conversationPanel.scrollHeight - conversationPanel.scrollTop;
          }, 100)
        }
      }
      const totalComponentsHeight = this.$refs.player.clientHeight + 87 + 100
      document.documentElement.clientHeight <= 890 ? this.userPlayerHeight = 'min-vh-100' : this.userPlayerHeight = 'userPlayerHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')
      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
  },
  created() {
    this.$store.commit('updateIsLoading', true)
    if (!this.role) this.$store.commit('updateRole', Cryptr.AES.decrypt(this.getCookie('userRole'), 'secret key 1234').toString(Cryptr.enc.Utf8))
    if (!this.isChatActivated) this.$store.commit('updateIsChatActivated', Cryptr.AES.decrypt(this.getCookie('isChat'), 'secret key 1234').toString(Cryptr.enc.Utf8) === 'true' ? true : false)
    this.verifyUser()
    const user = this.getCookie('email');
    this.code = this.$route.params.id
    this.chatsRef = app.database().ref(`lallucana/${this.code}/msg`)
    this.usersRef = app.database().ref(`lallucana/${this.code}/users`)
    if (!user) this.$router.push({path: '/'})
    //!user ? this.$router.push({path: '/'}) : this.verifyUserInFirebase()

    if (!this.panicPoster) this.$store.commit('updatePanicPoster', localStorage.getItem('panicPoster'))
  },
  mounted() {
    window.addEventListener("resize", this.matchHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  },
}
</script>

<style scoped>

</style>
